// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"school-search-panel_wrapper__qByKK"};